module.exports = __webpack_public_path__ + "static/media/close-icon.9dfce758.svg";